import useModelValue from './use-model-value'
import useModelKeyName from './use-model-key-name'

export default function useModelKey () {
  const modelKeyName = useModelKeyName()
  return useModelValue(modelKeyName)
}
